import { FC } from 'react';
import Typography from '@mui/material/Typography';
import { Column } from 'further-ui/components/Layout';

const RecipientList: FC = () => {
  return (
    <Column spacing="sm">
      <Column spacing="xs">
        <Typography variant="h5">Recipient list</Typography>
        <Typography variant="body2">All closed investors</Typography>
      </Column>
    </Column>
  );
};

export default RecipientList;
